__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/35b561c/_next/";